import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Sparkles, Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <Sparkles className="h-8 w-8 text-blue-600" />
              <span className="text-xl font-bold text-gray-900">ContentCraft AI</span>
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <Link to="/dashboard" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  ダッシュボード
                </Link>
                <Link to="/generate" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  生成
                </Link>
                <Link to="/history" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  履歴
                </Link>
                <Link to="/pricing" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  料金プラン
                </Link>
                <span className="text-gray-500 px-3">
                  {user.subscriptionTier === 'free' ? '無料' : user.subscriptionTier === 'basic' ? 'ベーシック' : 'プロ'}プラン
                </span>
                <button
                  onClick={handleLogout}
                  className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                >
                  ログアウト
                </button>
              </>
            ) : (
              <>
                <Link to="/guide" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  使い方
                </Link>
                <Link to="/pricing" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  料金プラン
                </Link>
                <Link to="/login" className="text-gray-700 hover:text-blue-600 px-3 py-2">
                  ログイン
                </Link>
                <Link
                  to="/register"
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
                >
                  今すぐ始める
                </Link>
              </>
            )}
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700 hover:text-blue-600"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {user ? (
              <>
                <Link
                  to="/dashboard"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  ダッシュボード
                </Link>
                <Link
                  to="/generate"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  生成
                </Link>
                <Link
                  to="/history"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  履歴
                </Link>
                <Link
                  to="/pricing"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  料金プラン
                </Link>
                <div className="px-3 py-2 text-gray-500">
                  {user.subscriptionTier === 'free' ? '無料' : user.subscriptionTier === 'basic' ? 'ベーシック' : 'プロ'}プラン
                </div>
                <button
                  onClick={() => {
                    handleLogout();
                    setMobileMenuOpen(false);
                  }}
                  className="block w-full text-left bg-red-600 text-white px-3 py-2 rounded-md hover:bg-red-700"
                >
                  ログアウト
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/guide"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  使い方
                </Link>
                <Link
                  to="/pricing"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  料金プラン
                </Link>
                <Link
                  to="/login"
                  className="block text-gray-700 hover:text-blue-600 px-3 py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  ログイン
                </Link>
                <Link
                  to="/register"
                  className="block bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  今すぐ始める
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;